import {HttpClient} from "@angular/common/http";
import {Injectable} from "@angular/core";
import {Observable} from "rxjs";
import {environment} from "../../../environments/environment";
import {ClassificationGroup} from "../../models/classification-group";
import Helpers from "../../utils/helpers";

@Injectable()
export class ClassificationGroupControllerService {

    private baseUrl: string = environment.BASE_URL;

    constructor(private http: HttpClient) {
    }

    public getClassificationsGroupsByType(classificationTypeId: string): Observable<ClassificationGroup[]> {
        return this.http.get(this.baseUrl + "type_classification_group/" + classificationTypeId) as Observable<ClassificationGroup[]>;
    }

    public getClassificationsGroupsByParentType(classificationTypeId: string): Observable<ClassificationGroup[]> {
        return this.http.get(this.baseUrl + "parent_type_classification_group/" + classificationTypeId) as Observable<ClassificationGroup[]>;
    }

    public createClassificationGroup(classificationTypeId: string, classificationGroup: ClassificationGroup): Observable<ClassificationGroup> {
      Helpers.trimRecursiveObj(classificationGroup);
      const body = JSON.stringify(classificationGroup);
      return this.http.post(this.baseUrl + "classification_group/" + classificationTypeId, body) as Observable<ClassificationGroup>;
    }

    public updateClassificationGroup(classificationGroup: ClassificationGroup): Observable<ClassificationGroup> {
      Helpers.trimRecursiveObj(classificationGroup);
      const body = JSON.stringify(classificationGroup);
      return this.http.put(this.baseUrl + "classification_group", body) as Observable<ClassificationGroup>;
    }

    public deleteClassificationGroup(classificationGroupId: string) {
        return this.http.delete(this.baseUrl + "classification_group/" + classificationGroupId, {responseType: "text"});
    }

    public getClassificationsGroups(): Observable<ClassificationGroup[]> {
        return this.http.get(this.baseUrl + "classification_group") as Observable<ClassificationGroup[]>;
    }

    public getClassificationsGroupsByField(classificationFieldId: string): Observable<ClassificationGroup[]> {
        return this.http.get(this.baseUrl + "field_classification_group/" + classificationFieldId) as Observable<ClassificationGroup[]>;
    }

    public updateSortOrder(classificationGroups: ClassificationGroup[]) {
        const body = JSON.stringify(classificationGroups);
        return this.http.put(this.baseUrl + "sort_classification_groups", body, {responseType: "text"});
    }
}
